import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';  // Import App.js
import './index.css';     // Import your styles (optional)
import { ChatProvider } from './context/ChatContext.js';
import { debugLog } from './utils/logging/debugLog';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ChatProvider>
      <App />
    </ChatProvider>
  </React.StrictMode>
);

// ✅ Register the Service Worker for PWA installability
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then(registration => {
        debugLog('✅ Service Worker registered:', registration);
      })
      .catch(error => {
        console.error('❌ Service Worker registration failed:', error);
      });
  });
}


